import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { toggleClass } from '../..//core/utils';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { CHIP_CONSTANTS } from '../chip/chip-constants';
import { CHIP_SET_CONSTANTS } from './chip-set-constants';
var ChipSetAdapter = /** @class */ (function (_super) {
    __extends(ChipSetAdapter, _super);
    function ChipSetAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(_this._component, CHIP_SET_CONSTANTS.selectors.ROOT);
        return _this;
    }
    ChipSetAdapter.prototype.setVertical = function (value) {
        toggleClass(this._rootElement, value, CHIP_SET_CONSTANTS.classes.VERTICAL);
    };
    ChipSetAdapter.prototype.setType = function (value) {
        var chips = this._getChips();
        chips.forEach(function (c) { return (c.type = value); });
    };
    ChipSetAdapter.prototype.setDense = function (value) {
        var chips = this._getChips();
        chips.forEach(function (c) { return (c.dense = value); });
    };
    ChipSetAdapter.prototype.setDisabled = function (value) {
        var chips = this._getChips();
        chips.forEach(function (c) { return (c.disabled = value); });
    };
    ChipSetAdapter.prototype._getChips = function () {
        return Array.from(this._component.querySelectorAll(CHIP_CONSTANTS.elementName));
    };
    return ChipSetAdapter;
}(BaseAdapter));
export { ChipSetAdapter };
